import {Component, Inject, Input, OnInit, Optional, ViewChild, ViewEncapsulation} from '@angular/core';
import * as SharedModels from '@shared-models/index';
import {ImageService} from '@ui-app/services/image.service';
import {ICroppPhotoRequestOld, UPLOAD_URL, UPLOAD_VISITOR_URL} from '@shared-models/common.models';
import {FileUploadService} from '@ui-app/components/file-upload/file-upload.service';
import {HttpClient} from '@angular/common/http';
import {ToastrService} from 'ngx-toastr';
import {SpinnerService} from '@ui-app/components/spinner/spinner.service';
import {IPhotoReviewGridModelWithCheckbox} from '@employee-pages/photo-review/photo-review.component';
import {BaseModal} from '@ui-app/modals/base-modal';
import {ApiConfig} from '@employee-configs/api.config';
import {filter, switchMap, map, catchError} from 'rxjs/operators';
import {IBoundingBox} from '@employee-models/data.models';
import Cropper from 'cropperjs';
import {EPhotoReviewMode, IAllCropperData, ICropperViewData} from './cropper.models';
import {CustomModalService} from '@ui-app/services/custom-modal.service';
import {ConfirmModalComponent} from '@ui-app/modals/confirm-modal/confirm-modal.component';
import {AutomaticCroppingService} from '@ui-app/services/automatic-cropping.service';
import {Observable,Subject} from 'rxjs';
import {BadgeRequestsService} from '../../core/services/data-access/badge-requests.service';

@Component({
    selector: 'employee-photo-review-modal',
    templateUrl: './photo-review-modal.component.html',
    styleUrls: ['./photo-review-modal.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class PhotoReviewModalComponent extends BaseModal implements OnInit {
    @Input() hideActionButtons = false; 
    @Input() showEditPhotoOption = false; 
    @Input() isFromProfile = false;
    @Input() onPhotoUpdated: () => void;
    @Input() onCancelEditing: () => void;

    
    
    
   
    
    get isEditMode(): boolean {
        return this.currentMode === EPhotoReviewMode.edit;
    }

    get getCropperViewData(): ICropperViewData {
        const data = this.cropper ? this.cropper.getData() : {} as ICropperViewData;
        return {
            width: data.width ? Math.trunc(data.width) : 0,
            height: data.height ? Math.trunc(data.height) : 0,
        };
    }

    get originalImageSource(): string {
        return this.originalPhotoGuidUrl;
    }

    get cropperData(): IAllCropperData {
        return {
            data: this.cropper.getData(),
            cropBoxData: this.cropper.getCropBoxData(),
            canvasData: this.cropper.getCanvasData()
        };
    }

    set cropperData(cropperData: IAllCropperData) {
        this.cropper.rotate(cropperData.data.rotate);
        this.cropper.setCropBoxData(cropperData.cropBoxData);
        this.cropper.setCanvasData(cropperData.canvasData);
    }
    isImageRecognitionEnabled: boolean;

    constructor(
        private http: HttpClient,
        private imageService: ImageService,
        private toasterService: ToastrService,
        private spinnerService: SpinnerService,
        private customModalService: CustomModalService,
        private automaticCroppingService: AutomaticCroppingService,
        private badgeRequestsService: BadgeRequestsService,
        @Optional() @Inject(UPLOAD_URL) public uploadUrl: string,
        @Optional() @Inject(UPLOAD_VISITOR_URL) public uploadVisitorUrl: string,
        @Optional() @Inject(FileUploadService) public fileUploadService: FileUploadService
    ) {
        super();
    }

    imageSource: string;
    originalPhotoGuidUrl: string;
    isApproveAndDeclineButton: boolean;
    isFurtherReviewButton: boolean;
    isVisibleEditPhotoBtn: boolean;
    cropper: Cropper;
    outputImage: string;
    isCorrectData = false;
    isDirty = false;
    currentMode: EPhotoReviewMode = EPhotoReviewMode.view;
    cropperSettings: Cropper.Options<HTMLImageElement>;
    minSizeOriginalPhoto: ICropperViewData = {
        width: 250,
        height: 375
    };

    private get isVisitorPhotoCard(): boolean {
        return this.isFromProfile && this.badgeRequestsService.getIsVisitorRequest((this.card as any).categoryId);
    }

    private getPhotoDownloadUrl(uId: string): Observable<any> {
        return this.isVisitorPhotoCard
            ? this.badgeRequestsService.getVisitorDownloadUrl(uId)
            : this.badgeRequestsService.getDownloadUrl(uId);
    }

    private get photoUploadUrl(): string {
        return this.isVisitorPhotoCard ? this.uploadVisitorUrl : this.uploadUrl;
    }

    private getPhotoStreamUrl(uId: string): string {
        const baseUrl = this.isVisitorPhotoCard ? ApiConfig.File.fileVisitorUrl : ApiConfig.File.fileUrl;
        return `${baseUrl}/${uId}`;
    }

    @Input() buttonsTitle = { dismiss: 'Close' };
    @Input() card: IPhotoReviewGridModelWithCheckbox;
    @ViewChild('image', { static: false }) imageElement;
    @Input() onApprovePhotoCallback = () => {};
    @Input() onDeclinePhotoCallback = () => {};
    @Input() furtherPhotoReviewCallback = () => {};
    ngOnInit(): void {
        const isValidPhotoSts = [
            SharedModels.CE.PhotoStatusEnum.FurtherReview,
            SharedModels.CE.PhotoStatusEnum.ApprovalPending
        ].includes(this.card.photoRequestStatusId);

        const isValidBadgeSts = [
            SharedModels.CE.BadgeStatusEnum.Pending,
            SharedModels.CE.BadgeStatusEnum.PendingPhotoCompliance
        ].includes(this.card.badgeRequestStatusId);

        const isValidFurtherReviewPhotoSts = this.card.photoRequestStatusId === SharedModels.CE.PhotoStatusEnum.ApprovalPending;

        const isSizePhotoCorrect = this.card.height >= this.minSizeOriginalPhoto.height
            && this.card.width >= this.minSizeOriginalPhoto.width;

        //this.isVisibleEditPhotoBtn = isValidPhotoSts && isValidBadgeSts && isSizePhotoCorrect;

        // Update isVisibleEditPhotoBtn to prioritize showEditPhotoOption
        this.isVisibleEditPhotoBtn = this.showEditPhotoOption || (isValidPhotoSts && isValidBadgeSts && isSizePhotoCorrect);
        this.isApproveAndDeclineButton = isValidPhotoSts && isValidBadgeSts;
        this.isFurtherReviewButton = isValidBadgeSts && isValidFurtherReviewPhotoSts;

        if (this.card.photoGuid) {
            if (this.isFromProfile) {
                // Updated logic for ProfileComponent
                this.subs = this.getPhotoDownloadUrl(this.card.photoGuid).subscribe(photoGuid => {
                    const elementId = 'ImageId_' + this.card.badgeRequestId;
                    const element = document.getElementById(elementId);
                    if (element) {
                        const srcValue = element.getAttribute('src') ?? '';
                        console.log(srcValue);
                        this.imageSource = srcValue;
                    } else {
                        this.imageSource = photoGuid.url;
                    }
                });
            } else {
                // Existing logic for PhotoReviewComponent
                this.subs = this.getPhotoDownloadUrl(this.card.photoGuid).subscribe(photoGuid => {
                    const elementId = 'ImageId_' + this.card.badgeRequestId;
                    const element = document.getElementById(elementId);
                    if (element) {
                        const srcValue = element.getAttribute('src') ?? '';
                        console.log(srcValue);
                        this.imageSource = srcValue;
                    } else {
                        this.imageSource = photoGuid.url;
                    }
                });
            }
        }

        const originalPhotoGuid = this.card.originalPhotoGuid || this.card.photoGuid;
        if (originalPhotoGuid) {
            this.originalPhotoGuidUrl = this.getPhotoStreamUrl(originalPhotoGuid);
        }
        this.subs = this.automaticCroppingService.getSetting().subscribe((settings) => {
            this.isImageRecognitionEnabled = settings.isImageRecognitionEnabled;
        });
    }

    onPhotoReview(): void {
        this.spinnerService.next(true);
        this.initCropperSettings(this.card.croppInfo);
        this.togglePhotoReviewModalMode();
    }

    cropperInit(img: any): void {
        this.cropper = new Cropper(img, this.cropperSettings);
    }

    onCropImageError(): void {
        this.spinnerService.next(false);
        this.toasterService.error('Photo could not be loaded. Please refresh the page and try again');
    }

    savePhotoFirstStep(request: ICroppPhotoRequestOld, dataUrl: string): Observable<any> {
        if (this.isImageRecognitionEnabled) {
            return this.automaticCroppingService
                .changeSizeAndCropPhoto(request, dataUrl, this.photoUploadUrl);
        }
        return this.fileUploadService
        .uploadFile(this.imageService.fromDataUrlToFile(dataUrl, 'filename'), this.photoUploadUrl)
        .pipe(
            switchMap((response) => {
                return this.http.post(`${ApiConfig.ImageRekognition.croppPhoto}`, {...request, uId: response.uId});
            }),
        );
    }
    savePhoto(): void {
        const request = {
            badgeRequestId: this.card.badgeRequestId,
            croppInfo: JSON.stringify(this.cropperData),
            isAutocropped: false,
            uId: null
        };
        this.card.croppInfo = request.croppInfo;

       const dataUrl= this.cropper.getCroppedCanvas().toDataURL('image/png');
       this.imageSource=dataUrl

        this.subs = this.savePhotoFirstStep(request, dataUrl)
        .subscribe(__ => {
                const element = document.getElementById('ImageId_'+this.card.badgeRequestId);
                    if (element) {
                        element.setAttribute('src', dataUrl);
                    }
                 this.toasterService.success('Photo was cropped');

                 if (this.onPhotoUpdated) {
                    this.onPhotoUpdated(); // Call the parent callback
                }
                this.action(true);

            }, __ => {
                this.toasterService.error('Photo can\'t be changed. Please refresh the page and try again');
                this.action(true);
            });
    }

    onResetToOriginal(): void {
        this.subs = this.customModalService.initModal(ConfirmModalComponent, {
            description: 'Results of cropping will be deleted. Are you sure you want to reset photo to original?'
        })
            .pipe(filter((isConfirmed: boolean) => isConfirmed))
            .subscribe(() => this.resetCroppPhoto());
    }

    resetCroppPhoto(): void {
        const request = {
            badgeRequestId: this.card.badgeRequestId,
            uId: this.card.originalPhotoGuid,
            croppInfo: null
        };
        this.card.croppInfo = null;
    
        this.subs = this.http.post(`${ApiConfig.ImageRekognition.croppPhoto}`, request).pipe(
            switchMap(_ => {
                // Call the second API after the first one completes
                return this.badgeRequestsService.getDownloadUrl(this.card.photoGuid);
            }),
    
        ).subscribe(
            photoGuid => {
                if (photoGuid) {
                    this.imageSource = photoGuid.url;
                    const element = document.getElementById('ImageId_' + this.card.badgeRequestId);
                    if (element) {
                        element.setAttribute('src', this.imageSource);
                    }
                    this.toasterService.success('Photo was reset to original');
                }
                if (this.onPhotoUpdated) {
                    this.onPhotoUpdated(); // Call the parent callback
                }
                this.action(true);
            },
            error => {
                this.toasterService.error('Photo can\'t be changed. Please refresh the page and try again');
                this.action(true);
            }
        );
    }

    rotate(degree: number): void {
        this.cropper.rotate(degree);
        this.isDirty = true;
        this.checkIsDisabledSavePhotoBtn();
    }

    private togglePhotoReviewModalMode(): void {
        this.currentMode = this.isEditMode ? EPhotoReviewMode.view : EPhotoReviewMode.edit;
    }

    private initCropperSettings(cropperData: IBoundingBox | string): void {
        cropperData = null;
        this.cropperSettings = {
            background: true,
            dragMode: 'move',
            aspectRatio: 2 / 3,
            autoCropArea: 1,
            autoCrop: true,
            modal: true,
            guides: true,
            center: true,
            scalable: true,
            zoomable: true,
            cropBoxMovable: true,
            cropBoxResizable: true,
            checkCrossOrigin: false,
            ready: () => {
                if (cropperData) {
                    if (typeof cropperData === 'string') {
                        this.cropperData = JSON.parse(cropperData);
                    } else {
                        const imageData = this.cropper.getImageData();
                        const canvasData = this.cropper.getCanvasData();

                        this.cropper.setCropBoxData({
                            top: canvasData.top + (imageData.height * cropperData.top),
                            left: canvasData.left + (imageData.width * cropperData.left),
                            height: imageData.height * cropperData.height,
                            width: imageData.width * cropperData.width
                        });
                    }

                    this.checkIsDisabledSavePhotoBtn();
                }

                this.spinnerService.next(false);
            },
            cropend: () => {
                this.isDirty = true;
                this.checkIsDisabledSavePhotoBtn();
            },
            zoom: () => {
                this.isDirty = true;
                this.checkIsDisabledSavePhotoBtn();
            }
        };
    }

    private checkIsDisabledSavePhotoBtn(): void {
        setTimeout(_ => {
            this.isCorrectData = this.isDirty
                && this.getCropperViewData.width >= this.minSizeOriginalPhoto.width
                && this.getCropperViewData.height >= this.minSizeOriginalPhoto.height;
        }, 0);
    }

    action(close: boolean): void {
        if (close) { // Check if the modal should be closed
            if (this.onCancelEditing) { // Check if the parent provided an onCancelEditing callback
                this.onCancelEditing(); // Notify the parent component to close the modal
            } else {
                this.customModalService.closeModal(PhotoReviewModalComponent); // Fallback: Close the modal directly
            }
        }
    }
}

function of(arg0: null) {
    throw new Error('Function not implemented.');
}

